// Registers dayjs plugins once for the whole app. Imported from main.tsx and
// listed in package.json "sideEffects", so feature modules can use
// .utc() / .tz() / .isBetween() / .fromNow() without depending on import order.
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
